import React from 'react';
import PropTypes from 'prop-types';
import MapListItem from './map-list-item';

class MapList extends React.Component {
  static propTypes = {
    maps: PropTypes.array,
    onViewMap: PropTypes.func,
  }
  render() {
    const { maps } = this.props;
    if(!maps || maps.constructor.name !== 'Array') {
      return <noscript />
    }
    return (
      <div style={{maxHeight: '350px', 'overflowY': 'auto'}}>
        <ul className="map-list">
          {!maps || maps.length == 0? <div className="alert alert-info text-center mb-none">None.</div>: ''}
          {maps.map((map, idx) => map ?
            <MapListItem
              key={map._id}
              onViewMap={this.props.onViewMap}
              onClick={this.props.onMapClick ? event => this.props.onMapClick(map, event) : null} 
              map={map} /> :
            <span key={idx} />)}
        </ul>
      </div>
    )
  }
}

export default MapList;



// WEBPACK FOOTER //
// ./src/browser/components/maps/map-list.js